module.exports = __webpack_public_path__ + "img/chufa_scenario_icon.87e82a8c.png";